import { SIGFOX, STANDALONE, WIFI } from "./comsTypes";

export const coms_priority_ENUM = {
  0: STANDALONE,
  1: SIGFOX,
  2: SIGFOX,
  3: WIFI,
  4: WIFI,
};
